import { Stack } from '@fluentui/react';
import { ActionButton, IconButton } from 'office-ui-fabric-react/lib/Button';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { Persona, PersonaPresence, PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import Scriba from 'react-scriba';
import PerimetreContext from '../../contexts/PerimetreContext';
import { Data } from '../../data/Data';
import { Immocom } from '../../specifique/immocom';
import { EUIPanel } from '../EUI/EUIPanel';
import { FicheCompte } from '../Fiche/FicheCompte';
import './Header.css';
import { PanelApplications } from './PanelApplications';

export class Header extends Component {
    static contextType = PerimetreContext;
    render = () => {
        const { perimetre } = this.context;
        return <HeaderWithPerimetre {...this.props} perimetre={perimetre} />;
    };
};

class HeaderWithPerimetre extends Component {

    static defaultProps = {
        perimetre: {}
    };

    static defaultState = {
        email: null,
        initiales: null,
        isAuthenticated: false,
        jeton: null,
        plateforme: "",
        urlEBook: "",
        urlPrimPromo: "",
        urlSectionMandat: "",
        username: null,
        version: "",
        /* --- */
        afficherPanelAide: false,
        afficherPanelApplications: false,
        afficherPanelMonCompte: false,
        afficherPanelProfil: false,
        afficherTuileAdministrationsDesVentesV4: false,
        afficherTuileAlarme: false,
        afficherTuileBackOfficeCapsuleClient: false,
        afficherTuileBackOfficeDemande: false,
        afficherTuileConfiguration: false,
        afficherTuileControleDeGestion: false,
        afficherTuileDocument: false,
        afficherTuileEBook: false,
        afficherTuileMandat: false,
        afficherTuileNews: false,
        afficherTuileOperation: false,
        afficherTuilePrimPromo: false,
        afficherTuileProspection: false,
        afficherTuileReporting: false,
        afficherTuileSignatureEiffage: false,
        afficherTuileTableauDeBord: false,
        afficherTuileVente: false,
    };

    constructor(props) {
        super(props);
        this.state = { ...HeaderWithPerimetre.defaultState };
    };

    _connexion = () => {
        Immocom.deconnexionEtRedirectionVersLogin();
    };

    _deconnexion = () => {
        Data._onDeconnexion().then(responseFetch => Immocom.deconnexionEtRedirectionVersLogin());
    };

    _getUtilisateurConnecteAinsiQueSonJeton = () => {
        Data._chargementGetUtilisateurConnecte().then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const valeurRetour = responseFetch.reponseAPIobjet;
                const monCompte = valeurRetour[0] || {};

                const { droitAccesFormulaireAdministrationsDesVentesV4, droitAccesFormulaireMandatSociete, droitAccesFormulaireAlarme, droitAccesBackOfficeCapsuleClient, droitAccesBackOffice, droitAccesFormulaireIndicateur, droitAccesFormulaireDocument, droitAccesEbook, droitAccesFormulaireMandat, droitAccesFormulaireOperation, droitAccesPrimPromo, droitAccesFormulaireContact, droitAccesFormulaireReporting, droitAccesFormulaireSignatureEiffage, droitAccesFormulaireVente } = monCompte;
                const { estExterne, estReseau, compteTrav } = monCompte;
                const { nom, prenom, email, adminNational } = compteTrav;

                const urlSectionMandat = droitAccesFormulaireMandatSociete || estExterne || estReseau
                    ? "/Mandat/ListeMandatsSociete/Type/Societe"
                    : "/Mandat/ListeMandatsEiffage/Type/Eiffage";

                this.setState({
                    email: email,
                    initiales: valeurRetour[1],
                    isAuthenticated: true,
                    jeton: valeurRetour[3],
                    plateforme: valeurRetour[6],
                    redirectionADVVersV2: valeurRetour[7],
                    urlEBook: valeurRetour[4],
                    urlPrimPromo: valeurRetour[5],
                    urlSectionMandat: urlSectionMandat,
                    urlV2: valeurRetour[2],
                    username: nom + ' ' + prenom,
                    version: valeurRetour[9],

                    afficherTuileAdministrationsDesVentesV4: droitAccesFormulaireAdministrationsDesVentesV4,
                    afficherTuileAlarme: droitAccesFormulaireAlarme,
                    afficherTuileBackOfficeCapsuleClient: droitAccesBackOfficeCapsuleClient,
                    afficherTuileBackOfficeDemande: droitAccesBackOffice,
                    afficherTuileConfiguration: adminNational,
                    afficherTuileControleDeGestion: droitAccesFormulaireIndicateur,
                    afficherTuileDocument: droitAccesFormulaireDocument,
                    afficherTuileEBook: droitAccesEbook,
                    afficherTuileMandat: droitAccesFormulaireMandat,
                    afficherTuileNews: true,
                    afficherTuileOperation: droitAccesFormulaireOperation,
                    afficherTuilePrimPromo: droitAccesPrimPromo,
                    afficherTuileProspection: droitAccesFormulaireContact,
                    afficherTuileReporting: droitAccesFormulaireReporting,
                    afficherTuileSignatureEiffage: droitAccesFormulaireSignatureEiffage,
                    afficherTuileTableauDeBord: true,
                    afficherTuileVente: droitAccesFormulaireVente,
                });
            }
            else Immocom.onTraitementErreurAvecState(this, { ...HeaderWithPerimetre.defaultState }, retourVerif, responseFetch);
        });
    };

    _regenererJeton = () => {
        Data._onGenerationJetonRetour().then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const objetData = responseFetch.reponseAPIobjet;
                this.setState({ jeton: objetData });
                //this.props.onReinitPerimetreChange();
            }
            else Immocom.onTraitementErreurAvecState(this, { jeton: null }, retourVerif, responseFetch);
        });
    };

    _renderPanelAide = () => {

        const { afficherPanelAide, afficherTuileControleDeGestion, afficherTuileDocument, afficherTuileMandat, afficherTuileOperation, afficherTuilePrimPromo, afficherTuileProspection, afficherTuileVente, } = this.state;

        return <EUIPanel
            headerText="Aide"
            isOpen={afficherPanelAide}
            onDismiss={this._togglePanel("Aide", false)}
        >
            <ActionButton
                iconProps={{ iconName: 'Mail' }}
                allowDisabledFocus={true}
                href="mailto:immocom.eiffage-immobilier@eiffage.com"
                className="noUnderline textAlignLeft"
            >
                Support technique Immocom
            </ActionButton>

            {afficherTuileVente &&
                <ActionButton
                    iconProps={{ iconName: 'OpenFile' }}
                    allowDisabledFocus={true}
                    className="noUnderline textAlignLeft"
                    onClick={() => {
                        this._telechargerDocument('Fiche d\'aide Signature électronique client(s).pdf')
                    }}
                >
                    Réservation et signature électronique client
                </ActionButton>
            }

            {afficherTuileProspection &&
                <ActionButton
                    iconProps={{ iconName: 'OpenFile' }}
                    allowDisabledFocus={true}
                    className="noUnderline textAlignLeft"
                    onClick={() => {
                        this._telechargerDocument('Fiche d\'aide Prospection.pdf')
                    }}
                >
                    Fiche d’aide Prospection
                </ActionButton>
            }

            <ActionButton
                iconProps={{ iconName: 'OpenFile' }}
                allowDisabledFocus={true}
                className="noUnderline textAlignLeft"
                onClick={() => {
                    this._telechargerDocument('Eiffimmo - Utilisation générale.pdf')
                }}
            >
                Utilisation générale
            </ActionButton>

            {afficherTuileDocument &&
                <ActionButton
                    iconProps={{ iconName: 'OpenFile' }}
                    allowDisabledFocus={true}
                    className="noUnderline textAlignLeft"
                    onClick={() => {
                        this._telechargerDocument('Tuile Documents.pdf')
                    }}
                >
                    Tuile Documents
                </ActionButton>
            }

            {afficherTuileMandat &&
                <ActionButton
                    iconProps={{ iconName: 'OpenFile' }}
                    allowDisabledFocus={true}
                    className="noUnderline textAlignLeft"
                    onClick={() => {
                        this._telechargerDocument('Tuile Mandat Opérationnels.pdf')
                    }}
                >
                    Tuile Mandat Opérationnels
                </ActionButton>
            }

            {afficherTuileOperation &&
                <ActionButton
                    iconProps={{ iconName: 'OpenFile' }}
                    allowDisabledFocus={true}
                    className="noUnderline textAlignLeft"
                    onClick={() => {
                        this._telechargerDocument('Tuile Opération.pdf')
                    }}
                >
                    Tuile Opération
                </ActionButton>
            }

            {/* 20230516 : YD : 2419 */}
            {afficherTuilePrimPromo &&
                <ActionButton
                    iconProps={{ iconName: 'OpenFile' }}
                    allowDisabledFocus={true}
                    className="noUnderline textAlignLeft"
                    onClick={() => {
                        this._telechargerDocument('Formation Bilan PrimPromo.pdf')
                    }}
                >
                    Formation Bilan PrimPromo
                </ActionButton>
            }

            {/* 20230516 : YD : 2419 */}
            {afficherTuileControleDeGestion &&
                <ActionButton
                    iconProps={{ iconName: 'OpenFile' }}
                    allowDisabledFocus={true}
                    className="noUnderline textAlignLeft"
                    onClick={() => {
                        this._telechargerDocument('Guide du contrôle budgétaire.pdf')
                    }}
                >
                    Guide du contrôle budgétaire
                </ActionButton>
            }

        </EUIPanel>;

    };

    _renderPanelProfil = () => {

        const { afficherPanelProfil, isAuthenticated } = this.state;

        if (isAuthenticated)
            return <EUIPanel
                headerText="Mon profil"
                isOpen={afficherPanelProfil}
                onDismiss={this._togglePanel("Profil", false)}
            >
                <div style={{ margin: "20px auto" }}>
                    <Persona
                        hidePersonaDetails={false}
                        imageInitials={this.state.initiales}
                        initialsColor="#fd0400"
                        presence={PersonaPresence.none}
                        secondaryText={this.state.email}
                        size={PersonaSize.size48}
                        text={this.state.username}
                    />
                </div>
                <div className="profilLink">
                    <Label onClick={this._togglePanel("MonCompte", true)}>Mon compte</Label>
                </div>
                <div className="profilLink">
                    <Label onClick={this._deconnexion}>Déconnexion</Label>
                </div>
            </EUIPanel>;

        else return <EUIPanel
            headerText="Identification"
            isOpen={afficherPanelProfil}
            onDismiss={this._togglePanel("Profil", false)}
        >
            <div style={{ marginTop: "20px" }}>
                <div className="profilLink">
                    <Label onClick={this._connexion}>Connexion</Label>
                </div>
            </div>
        </EUIPanel>;

    };

    _telechargerDocument = (filename) => {
        Data._chargementDocumentAide(filename).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const objetData = responseFetch.reponseAPIobjet;
                const document = Scriba.fichier().Base64VersByteArray(objetData.fileData);
                return Scriba.fichier().EnregisterSous(document, objetData.nom);
            }
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });
    };

    _togglePanel = (nomPanel, isOpen) => () => {
        this.setState({ [`afficherPanel${nomPanel}`]: isOpen });
    };

    componentDidMount = () => {
        this._getUtilisateurConnecteAinsiQueSonJeton();
    };

    //componentDidUpdate = () => {
    //    if (this.props.onPerimetreChange)
    //        this._regenererJeton();
    //};

    componentDidUpdate = (prevProps) => {
        const { perimetre } = this.props;
        if (JSON.stringify(prevProps.perimetre) !== JSON.stringify(perimetre))
            this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    render = () => {

        const {
            afficherPanelMonCompte, afficherPanelApplications, afficherPanelAide,
            afficherTuileAdministrationsDesVentesV4, afficherTuileAlarme, afficherTuileBackOfficeCapsuleClient, afficherTuileBackOfficeDemande, afficherTuileConfiguration, afficherTuileControleDeGestion, afficherTuileDocument, afficherTuileEBook, afficherTuileMandat, afficherTuileNews, afficherTuileOperation, afficherTuilePrimPromo, afficherTuileProspection, afficherTuileReporting, afficherTuileSignatureEiffage, afficherTuileTableauDeBord, afficherTuileVente,
            initiales, isAuthenticated, jeton, urlEBook, urlPrimPromo, urlSectionMandat, plateforme, version
        } = this.state;
        const droits = { afficherTuileAdministrationsDesVentesV4, afficherTuileAlarme, afficherTuileBackOfficeCapsuleClient, afficherTuileBackOfficeDemande, afficherTuileConfiguration, afficherTuileControleDeGestion, afficherTuileDocument, afficherTuileEBook, afficherTuileMandat, afficherTuileNews, afficherTuileOperation, afficherTuilePrimPromo, afficherTuileProspection, afficherTuileReporting, afficherTuileSignatureEiffage, afficherTuileTableauDeBord, afficherTuileVente };

        return <Fragment>

            <Stack horizontal horizontalAlign="space-between" verticalAlign="center" styles={{ root: { backgroundColor: "#575757", color: "#fff" } }} gap="16px">

                <Stack horizontal verticalAlign="center" gap="16px">
                    <IconButton iconProps={{ iconName: 'Waffle' }} title="Menu" ariaLabel="Menu" className="headerMenuButton" onClick={this._togglePanel("Applications", true)} />

                    <PanelApplications
                        droits={droits}
                        isOpen={afficherPanelApplications}
                        onDismiss={this._togglePanel("Applications", false)}
                        urlEBook={urlEBook + "Jwt=" + jeton + "&"}
                        urlPrimPromo={urlPrimPromo + "Jwt=" + jeton}
                        urlSectionMandat={urlSectionMandat}
                    />

                    <a href="https://www.eiffage-immobilier.fr/" target="_blank" rel="noopener noreferrer" className="brandLink ms-hiddenLgDown"><span className="brandText">Eiffage-Immobilier.fr</span></a>

                    <div className="ms-hiddenLgDown" style={{ border: ".5px solid white", height: "20px" }} />

                    <Link to="/" className="appTitle">
                        <span className="ms-hiddenLgDown brandText titreEiffimmo">Eiffimmo{!!version && ` (${version})`}</span>
                    </Link>

                    {!!plateforme &&
                        <Link to="/" className="appTitle">
                            <span className="ms-hiddenLgDown brandText titreEiffimmo" style={{ backgroundColor: "yellow", color: "black" }}>{plateforme}</span>
                        </Link>
                    }

                </Stack>

                <div>
                    <IconButton iconProps={{ iconName: 'Help' }} title="Aide" ariaLabel="Aide" className="rightMenuButton ms-hiddenLgDown" onClick={this._togglePanel("Aide", true)} />
                    {isAuthenticated
                        ? <button className="rightMenuButton" onClick={this._togglePanel("Profil", true)}>
                            <Persona
                                imageInitials={initiales}
                                size={PersonaSize.size32}
                                presence={PersonaPresence.none}
                                hidePersonaDetails={true}
                                initialsColor="#fd0400"
                            />
                        </button>
                        : <IconButton iconProps={{ iconName: 'Permissions' }} title="Identification" ariaLabel="Identification" className="rightMenuButton" onClick={this._togglePanel("Profil", true)} />
                    }
                </div>

            </Stack>

            <FicheCompte
                loginCompte={sessionStorage.getItem("loginCompte")}
                onAffichePanelCompte={afficherPanelMonCompte}
                onAnnuleFiche={this._togglePanel("MonCompte", false)}
                onEnregistrementFiche={this._togglePanel("MonCompte", false)}
            />

            {this._renderPanelAide()}

            {this._renderPanelProfil()}

        </Fragment>;

    };

};